// import components
import { styled, Box, Divider } from '@mui/material';

export const StyledListViewTableBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3)
}));

export const StyledListViewTableCheckBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: theme.spacing(0.5),
  marginBottom: theme.spacing(1)
}));

export const StyledTotalDurationBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(12.5)
}));

export const StyledListViewDivider = styled(Divider)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(3),
  borderStyle: 'dashed'
}));
